import { memo } from "react"

const LoginFormSeparator = memo(({ title }: { title: string }) => {
    return (
        <div className="flex items-center justify-center w-full gap-4">
            <Line />
            <h3 className="text-black-500">{title}</h3>
            <Line />
        </div>
    )
})
LoginFormSeparator.displayName = "LoginFormSeparator"
export { LoginFormSeparator }

const Line = () => {
    return <div className="h-px flex-1 bg-ivory" />
}
